import React from 'react'
import {Link} from 'react-router'

export default function Error404 ({ resource="Page" }) {
  return (
    <main>
      <header className="banner">
        <h1 className="banner__title">
          Error 404: { resource } Not Found
        </h1>
        <Link to="/" className="banner__left-action">
          <span aria-hidden="true">‹</span>
          <span className="hide-visually">Return Home</span>
        </Link>
      </header>

      <img alt="Page not Found" src="/images/turtles.gif" className="block-level--fill" />
    </main>
  )
}



/** WEBPACK FOOTER **
 ** ./web/static/app/components/notfound.jsx
 **/